import React, { useEffect, useRef, useState } from 'react';
import { SearchInput, SearchInputOption } from '@uhg-abyss/web/ui/SearchInput';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { ToggleSwitch } from '@uhg-abyss/web/ui/ToggleSwitch';
import { AdvanceSearchStyle, ContainerStyle, toggleSwitchCss } from './AdvancedSearchDropdown.style';

interface AdvancedSearchDropdownProps {
  inputKey?: number;
  placeholder?: string;
  noOptionsMessage?: string;
  searchLoading: boolean;
  width?: string;
  height?: string;
  options: any[];
  aiAssist?: boolean;
  searchValue?: string;
  onClear?: () => void;
  renderOption?: (optionItem: any) => React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  handleSearch: (searchValue: SearchInputOption) => void;
  handleInputChange?: (inputValue: string, isArrowKeyDown: boolean) => void;
  handleAIAssistToggle: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleApiFilter: (searchValue: string, currentValue : SearchInputOption | undefined) => void;
  customRender?: (
    optionItem: any
  ) => React.ReactElement<any, string | React.JSXElementConstructor<any>>;
}

const AdvancedSearchDropdown : React.FC<AdvancedSearchDropdownProps> = ({
    inputKey,
    placeholder,
    noOptionsMessage,
    searchLoading,
    options,
    aiAssist,
    width,
    searchValue,
    height,
    onClear,
    renderOption,
    handleSearch,
    handleApiFilter,
    handleInputChange,
    handleAIAssistToggle,
  }) => {

  const wrapperRef = useRef<HTMLDivElement>(null);

  const searchInputCss: any = {
    ...AdvanceSearchStyle,
    'abyss-search-input-root': {
      ...AdvanceSearchStyle['abyss-search-input-root'],
      maxWidth: width || AdvanceSearchStyle['abyss-search-input-root']?.maxWidth,
    },
    'abyss-search-input-icon-container': {
      ...AdvanceSearchStyle['abyss-search-input-icon-container'],
      display: searchValue?.length ? 'none !important' : 'flex !important',
    },
  };

  return (
    <>
      <ContainerStyle ref={wrapperRef}>
        <SearchInput
          key={inputKey ?? undefined}
          label=""
          hideLabel
          options={options}
          keys={['value']}
          optionIcon={<></>}
          css={searchInputCss}
          height={height}
          isLoading={searchLoading}
          placeholder={placeholder}
          openOnFocus
          onClear={onClear}
          onInputChange={handleInputChange}
          onSearch={handleSearch}
          customRender={renderOption}
          apiFiltering={handleApiFilter}
          debounceTime={1200}
          isClearable
          customLoader={
            <LoadingSpinner
              size="$sm"
              isLoading
              ariaLoadingLabel="Loading..."
            />
          }
          customNoOptionsMessage={noOptionsMessage}
        />
        {/* <ToggleSwitch
          label="AI Assist"
          isChecked={aiAssist}
          onChange={(e) => handleAIAssistToggle(e)}
          css={toggleSwitchCss}
        /> */}
      </ContainerStyle>
    </>
  );
};

export default AdvancedSearchDropdown;